module.exports = __webpack_public_path__ + "img/Recurso 39@300x l.7ed1af4a.png";